"use client"

import { HandFist } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HandFistIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HandFistIcon = component(Icon)({ as: HandFist })
